import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appBlockSpecialChars]',
  standalone: true
})
export class BlockSpecialCharsAndAlphabatesDirective {

  constructor(private el: ElementRef) {}

  private regex: RegExp = /[^0-9 .]/g;

  @HostListener('input')
  onInput() {
    const input = this.el.nativeElement;
    const cleanedValue = input.value.replace(this.regex,'');

    if (input.value !== cleanedValue) {
      input.value = cleanedValue;
      input.dispatchEvent(new Event('input'));
    }
  }
}